<script>
import '@/scss/_typography.scss'
import '@/scss/_utilities.scss'

export default {
  props: {
    title: {
      type: String,
      required: true,
      default: 'Digite seu titulo aqui...'
    }
  }
}
</script>

<template>
  <div class="mt-3 mb-2">
    <h4 class="m-0">{{ title }}</h4>
    <hr>
  </div>
</template>



// WEBPACK FOOTER //
// src/components(new)/UI/Typography/TitleWithRow/TitleWithRow.vue